
// import React, { useState } from 'react';
// import './StrengthsSection.css';

// const StrengthsSection = () => {
//   const strengths = [
//     { value: '4251 +', label: 'Completed Projects', emoji: '🏗️' },
//     { value: '451 +', label: 'Corporate Clients', emoji: '🏢' },
//     { value: '20 +', label: 'MWP Operating Capacity', emoji: '⚡' },
//     { value: '52 +', label: 'Solar Capacity Installed', emoji: '☀️' },
//     { value: '17 +', label: 'Years Experience', emoji: '📅' },
//     { value: '11 +', label: 'Locations in Maharashtra', emoji: '📍' }
//   ];

//   const [animating, setAnimating] = useState({});
//   const [displayValues, setDisplayValues] = useState(strengths.map(function(s) { return s.value; }));

//   const handleHover = function(index) {
//     if (animating[index]) return;
    
//     setAnimating(function(prev) {
//       var newAnimating = Object.assign({}, prev);
//       newAnimating[index] = true;
//       return newAnimating;
//     });
    
//     var strength = strengths[index];
//     var numericValue = parseInt(strength.value);
//     var count = 0;
//     var duration = 800;
//     var intervalTime = 20;
//     var steps = duration / intervalTime;
//     var increment = numericValue / steps;
    
//     var interval = setInterval(function() {
//       count += increment;
//       if (count >= numericValue) {
//         count = numericValue;
//         clearInterval(interval);
//         setDisplayValues(function(prev) {
//           var newValues = prev.slice();
//           newValues[index] = numericValue + ' +';
//           return newValues;
//         });
//         setTimeout(function() {
//           setAnimating(function(prev) {
//             var newAnimating = Object.assign({}, prev);
//             newAnimating[index] = false;
//             return newAnimating;
//           });
//         }, 300);
//       } else {
//         setDisplayValues(function(prev) {
//           var newValues = prev.slice();
//           newValues[index] = Math.floor(count) + ' +';
//           return newValues;
//         });
//       }
//     }, intervalTime);
//   };

//   const handleMouseLeave = function(index) {
//     setDisplayValues(function(prev) {
//       var newValues = prev.slice();
//       newValues[index] = strengths[index].value;
//       return newValues;
//     });
//     setAnimating(function(prev) {
//       var newAnimating = Object.assign({}, prev);
//       newAnimating[index] = false;
//       return newAnimating;
//     });
//   };

//   return React.createElement(
//     'section',
//     { className: 'strengths-section' },
//     React.createElement(
//       'div',
//       { className: 'container' },
//       React.createElement(
//         'div',
//         { className: 'strengths-header' },
//         React.createElement(
//           'h2',
//           { className: 'strengths-title' },
//           'Our Strengths'
//         )
//       ),
//       React.createElement(
//         'div',
//         { className: 'strengths-grid' },
//         strengths.map(function(strength, index) {
//           return React.createElement(
//             'div',
//             {
//               key: index,
//               className: 'strength-card',
//               onMouseEnter: function() { return handleHover(index); },
//               onMouseLeave: function() { return handleMouseLeave(index); }
//             },
//             React.createElement(
//               'div',
//               { className: 'strength-emoji' },
//               strength.emoji
//             ),
//             React.createElement(
//               'div',
//               { className: 'strength-value' + (animating[index] ? ' animating' : '') },
//               displayValues[index]
//             ),
//             React.createElement(
//               'div',
//               { className: 'strength-label' },
//               strength.label
//             )
//           );
//         })
//       )
//     )
//   );
// };

// export default StrengthsSection;

























// // components/StrengthsSection.js
// import React, { useState } from 'react';
// import './StrengthsSection.css';

// const StrengthsSection = () => {
//   const strengths = [
//     { value: '4251 +', label: 'Completed Projects', emoji: '🏗️' },
//     { value: '451 +', label: 'Corporate Clients', emoji: '🏢' },
//     { value: '20 +', label: 'MWP Operating Capacity', emoji: '⚡' },
//     { value: '52 +', label: 'Solar Capacity Installed', emoji: '☀️' },
//     { value: '17 +', label: 'Years Experience', emoji: '📅' },
//     { value: '11 +', label: 'Locations in Maharashtra', emoji: '📍' }
//   ];

//   const [animating, setAnimating] = useState({});
//   const [displayValues, setDisplayValues] = useState(strengths.map(function(s) { return s.value; }));

//   const handleHover = function(index) {
//     if (animating[index]) return;
    
//     setAnimating(function(prev) {
//       var newAnimating = Object.assign({}, prev);
//       newAnimating[index] = true;
//       return newAnimating;
//     });
    
//     var strength = strengths[index];
//     var numericValue = parseInt(strength.value);
//     var count = 0;
//     var duration = 800;
//     var intervalTime = 20;
//     var steps = duration / intervalTime;
//     var increment = numericValue / steps;
    
//     var interval = setInterval(function() {
//       count += increment;
//       if (count >= numericValue) {
//         count = numericValue;
//         clearInterval(interval);
//         setDisplayValues(function(prev) {
//           var newValues = prev.slice();
//           newValues[index] = numericValue + ' +';
//           return newValues;
//         });
//         setTimeout(function() {
//           setAnimating(function(prev) {
//             var newAnimating = Object.assign({}, prev);
//             newAnimating[index] = false;
//             return newAnimating;
//           });
//         }, 300);
//       } else {
//         setDisplayValues(function(prev) {
//           var newValues = prev.slice();
//           newValues[index] = Math.floor(count) + ' +';
//           return newValues;
//         });
//       }
//     }, intervalTime);
//   };

//   const handleMouseLeave = function(index) {
//     setDisplayValues(function(prev) {
//       var newValues = prev.slice();
//       newValues[index] = strengths[index].value;
//       return newValues;
//     });
//     setAnimating(function(prev) {
//       var newAnimating = Object.assign({}, prev);
//       newAnimating[index] = false;
//       return newAnimating;
//     });
//   };

//   return React.createElement(
//     'section',
//     { className: 'strengths-section' },
//     React.createElement(
//       'div',
//       { className: 'container' },
//       React.createElement(
//         'div',
//         { className: 'strengths-header' },
//         React.createElement(
//           'h2',
//           { className: 'strengths-title' },
//           'Our Strengths'
//         )
//       ),
//       React.createElement(
//         'div',
//         { className: 'strengths-grid' },
//         strengths.map(function(strength, index) {
//           return React.createElement(
//             'div',
//             {
//               key: index,
//               className: 'strength-card',
//               onMouseEnter: function() { return handleHover(index); },
//               onMouseLeave: function() { return handleMouseLeave(index); }
//             },
//             React.createElement(
//               'div',
//               { className: 'strength-emoji' },
//               strength.emoji
//             ),
//             React.createElement(
//               'div',
//               { className: 'strength-value' + (animating[index] ? ' animating' : '') },
//               displayValues[index]
//             ),
//             React.createElement(
//               'div',
//               { className: 'strength-label' },
//               strength.label
//             )
//           );
//         })
//       )
//     )
//   );
// };

// export default StrengthsSection;














// components/StrengthsSection.js
import React, { useState } from 'react';
import './StrengthsSection.css';

const StrengthsSection = () => {
  const strengths = [
    { value: '4251 +', label: 'Completed Projects', emoji: '🏗️' },
    { value: '451 +', label: 'Corporate Clients', emoji: '🏢' },
    { value: '20 +', label: 'MWP Operating Capacity', emoji: '⚡' },
    { value: '52 +', label: 'Solar Capacity Installed', emoji: '☀️' }
  ];

  const [animating, setAnimating] = useState({});
  const [displayValues, setDisplayValues] = useState(strengths.map(function(s) { return s.value; }));

  const handleHover = function(index) {
    if (animating[index]) return;
    
    setAnimating(function(prev) {
      var newAnimating = Object.assign({}, prev);
      newAnimating[index] = true;
      return newAnimating;
    });
    
    var strength = strengths[index];
    var numericValue = parseInt(strength.value);
    var count = 0;
    var duration = 800;
    var intervalTime = 20;
    var steps = duration / intervalTime;
    var increment = numericValue / steps;
    
    var interval = setInterval(function() {
      count += increment;
      if (count >= numericValue) {
        count = numericValue;
        clearInterval(interval);
        setDisplayValues(function(prev) {
          var newValues = prev.slice();
          newValues[index] = numericValue + ' +';
          return newValues;
        });
        setTimeout(function() {
          setAnimating(function(prev) {
            var newAnimating = Object.assign({}, prev);
            newAnimating[index] = false;
            return newAnimating;
          });
        }, 300);
      } else {
        setDisplayValues(function(prev) {
          var newValues = prev.slice();
          newValues[index] = Math.floor(count) + ' +';
          return newValues;
        });
      }
    }, intervalTime);
  };

  const handleMouseLeave = function(index) {
    setDisplayValues(function(prev) {
      var newValues = prev.slice();
      newValues[index] = strengths[index].value;
      return newValues;
    });
    setAnimating(function(prev) {
      var newAnimating = Object.assign({}, prev);
      newAnimating[index] = false;
      return newAnimating;
    });
  };

  return React.createElement(
    'section',
    { className: 'strengths-section' },
    React.createElement(
      'div',
      { className: 'container' },
      React.createElement(
        'div',
        { className: 'strengths-header' },
        React.createElement(
          'h2',
          { className: 'strengths-title' },
          'Our Strengths'
        )
      ),
      React.createElement(
        'div',
        { className: 'strengths-grid' },
        strengths.map(function(strength, index) {
          return React.createElement(
            'div',
            {
              key: index,
              className: 'strength-card',
              onMouseEnter: function() { return handleHover(index); },
              onMouseLeave: function() { return handleMouseLeave(index); }
            },
            React.createElement(
              'div',
              { className: 'strength-emoji' },
              strength.emoji
            ),
            React.createElement(
              'div',
              { className: 'strength-value' + (animating[index] ? ' animating' : '') },
              displayValues[index]
            ),
            React.createElement(
              'div',
              { className: 'strength-label' },
              strength.label
            )
          );
        })
      )
    )
  );
};

export default StrengthsSection;